module.exports = __webpack_public_path__ + "img/256x256_diamond_partial.80b17f30.svg";